/**
 * Patches the state according to it's configuration.
 *
 * @param {any} state - Any current store state.
 * @param {object} context - The current patching context.
 * @param {string} context.target - The target key.
 * @param {any} context.patch - The patch data.
 * @returns {any} - A fresh updated copy of the target.
 */
export default function (state, { target, patch }) {
  const copy = { ...state[target] }

  for (let key in patch) {
    if (typeof patch[key] === typeof copy[key]) copy[key] = patch[key]
  }
  return copy
}
